import ContextMenu from 'components/global/ContextMenu';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import { handleClickEditTeam } from 'components/views/InvestorTeam/_helpers/investorTeam.events';

const InvestorTeamRows = ({ data }) => data.map((row) => ({
  ...row,
  id: row.id,
  name: row.name,
  userCount: row.userCount,
  Actions: (
    <ContextMenu
      menuItems={[{
        label: 'Edit',
        onClick: () => handleClickEditTeam(row),
      }, {
        label: 'Delete',
        onClick: () => handleShowModal('delete-team', { id: row.id, name: row.name }),
      }]}
    />
  ),
}));

export default InvestorTeamRows;
